/* eslint-disable @typescript-eslint/naming-convention */

import { postDataToService } from '../../../../utils/common-utils'

export interface IraFormInput {
  firstName: string
  lastName: string
  emailAddress: string
  phone?: string | null
  financialIns: string
  interest: string
}

/*
 * Email structures
 */

export interface EmailInfo {
  emailApi: string
  fromAddress: string
  toAddress: string
  subject: string
}

/** Payload shape sent to postDataToService */
export interface EmailServiceRequest {
  url: string
  data: {
    type: 'email'
    data: {
      from: string
      to: string[]
      subject: string
      body: unknown
    }
  }
}

/** Minimal expected response from postDataToService */
export interface EmailServiceResponse {
  code?: string | number
  message?: string
  [key: string]: unknown
}

/** Callback signature used by sendEmail */
export type FormCallback = (response: unknown, status: string) => void

/*
 *  IRA form data
 */
export const getData = ({
  firstName,
  lastName,
  emailAddress,
  phone,
  financialIns,
  interest,
}: IraFormInput): Record<string, string> => ({
  'First Name': firstName,
  'Last Name': lastName,
  'Email': emailAddress,
  'Phone': phone ? phone : 'N/A',
  'Financial Institution': financialIns,
  'Key area of interests': interest,
})

/*
 *  Set DOM: safely shape HTML for dangerouslySetInnerHTML
 */
export const setInnerHtml = (html: string): { __html: string } => ({ __html: html })

/*
 *  Static Text (as a const object + type)
 */
export const CONSTs = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  CROSSDOMAIN: 'cross domain',
  CONTACTAFIG: 'Financial Institutions Group Contact Form',
} as const

/*
 *  Send email
 */
export const sendEmail = (
  serverData: unknown,
  emailInfo: EmailInfo | null | undefined,
  formCallback: FormCallback
): boolean => {
  if (!serverData || !emailInfo) {
    return false
  }

  const receivedData: EmailServiceRequest = {
    url: emailInfo.emailApi,
    data: {
      type: 'email',
      data: {
        from: emailInfo.fromAddress,
        to: [emailInfo.toAddress],
        subject: emailInfo.subject,
        body: serverData,
      },
    },
  }

  /*
   * Send form data to the postDataToService method in utils under common/fetch
   */
  postDataToService(receivedData)
    .then((response: EmailServiceResponse | undefined) => {
      if (response) {
        const message = response.message && String(response.message).toUpperCase()
        if (message === 'OK') {
          return formCallback(response, CONSTs.SUCCESS)
        } else {
          return formCallback(response, CONSTs.FAILURE)
        }
      } else {
        return formCallback(response, CONSTs.FAILURE)
      }
    })
    .catch((error: unknown) => formCallback(error, CONSTs.FAILURE))

  // Keep original behavior: return false synchronously
  return false
}
